import React from "react";
import Card from "react-bootstrap/Card";
import { sendAPIRequest } from "shared/utils/requests";

export default class IndexScoringFeedback extends React.Component {
  constructor(props) {
    super(props);

    this.state = { companyFeedback: this.props.companyFeedback };
  }

  markAsRead(companyName, eventId, currentContractorId) {
    sendAPIRequest("/qa_record/mark_as_read", "POST", {
      event_id: eventId,
      contractor_user_id: currentContractorId,
    });

    let companyFeedbackState = this.state.companyFeedback;
    delete companyFeedbackState[companyName][eventId];
    this.setState({ companyFeedback: companyFeedbackState });
  }

  render() {
    const currentContractorId = this.props.currentContractorId;
    const { companyFeedback } = this.state;

    return (
      <Card body>
        <h1 className="large">Daily Feedback</h1>
        <p>
          This feedback is from the SMEs. We do not use this feedback to rate
          your performance.
        </p>

        {Object.keys(companyFeedback).length === 0 && (
          <div>
            <br />
            <h1>All Clear. Score away!</h1>
          </div>
        )}

        {Object.keys(companyFeedback).length > 0 && (
          <div>
            {Object.keys(companyFeedback).map(companyName => {
              return (
                <div key={companyName}>
                  <br />
                  <h1>{companyName}</h1>
                  <table className="table">
                    <thead>
                      <tr>
                        <th>Statement</th>
                        <th>Incorrect Answers</th>
                        <th>Comments</th>
                        <th>Commenter</th>
                        <th>{}</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Object.keys(companyFeedback[companyName]).map(
                        eventId => {
                          const qars = companyFeedback[companyName][eventId];

                          return (
                            <tr key={eventId}>
                              <td>{qars[0].event_content}</td>
                              <td style={{ color: "red" }}>
                                <ul>
                                  {qars.map(q => (
                                    <li key={q.id}>
                                      {q.original
                                        ? ""
                                        : "[Omitted] " + q.skill_name}
                                    </li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <ul>
                                  {qars.map(q => (
                                    <li key={q.id}>{q.comment}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <ul>
                                  {qars.map(q => (
                                    <li key={q.id}>{q.qa_user_name}</li>
                                  ))}
                                </ul>
                              </td>
                              <td>
                                <button
                                  onClick={() =>
                                    this.markAsRead(
                                      companyName,
                                      eventId,
                                      currentContractorId
                                    )
                                  }
                                >
                                  Mark as read
                                </button>
                              </td>
                            </tr>
                          );
                        }
                      )}
                    </tbody>
                  </table>
                </div>
              );
            })}
          </div>
        )}
      </Card>
    );
  }
}
